import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { MrpProdsysLinkContainerModel } from '../../../../../../models/aggregates/mrp-prodsys';


@Injectable({
  providedIn: 'root'
})
export class MrpProdsysLinkService extends BaseApiTemplateService<MrpProdsysLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-prodsys-link"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-prodsys-link"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-prodsys-link"
    this.httpClient = http;
  }

}
